import { StyleSheet, Image } from 'react-native'
import React, { useEffect, useState } from 'react'
import { ThemedView, ThemedText } from '@app/theme'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import { trackEvent } from '@app/utils/amplitude'

type PopularBanksProps = {
  banks: Record<string, string>
  onBankSelect: (bankCode: string, bankName: string) => void
  }

const RenderBankImage = ({ bankCode }: { bankCode: string }) => {

  const [bankLogo, setBankLogo] = useState<string>(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode}.png`)

  useEffect(() => {
    setBankLogo(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode}.png`)
  }, [bankCode])

  return (
    <Image
      resizeMode="contain"
      onError={() => {
        setBankLogo('https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png')
      }}
      style={styles.bankLogo}
      source={{ uri: bankLogo }}
    />
  )
}

const PopularBanks = React.memo(({ banks , onBankSelect }: PopularBanksProps) => {


  const handleBankPress = (bankId: string) => {
    trackEvent('ADDBANK_BANK_SELECTED', { bankName : banks[bankId] })
    onBankSelect(bankId, banks[bankId])
    trackEvent('BANK_SELECT_POPULAR_BANKS_SELECTED', { bankId })
  }

    const renderBank = (code: string, name: string) => (
    <ThemedTouchableOpacity key={code} onPress={() => handleBankPress(code)} style={styles.bankContainer}>
      <RenderBankImage key={code} bankCode={code} />
      <ThemedText numberOfLines={1} ellipsizeMode='tail' variant="b4r">{name}</ThemedText>
    </ThemedTouchableOpacity>
  )

  return (
    <ThemedView>
      <ThemedText variant="b3s" mb='lg'>Popular banks</ThemedText>
      <ThemedView style={styles.grid}>
        {Object.entries(banks).map(([code, name]) => renderBank(code , name))}
      </ThemedView>
    </ThemedView>
  )
})

export default PopularBanks

const styles = StyleSheet.create({
 
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: '4%', 
    marginBottom: 24, 
    justifyContent: 'space-between',
  },
  bankContainer: {
    alignItems: 'center',
    width: '22%', 
    marginBottom: 20,
  },
  bankLogo: {
    width: 48,
    height: 48,
    marginBottom: 4,
  },
})
